"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var colors = {
  primary: {
    default: '#CF1F2E'
  },
  secondary: {
    default: '#1B1B1B',
    1: '#ED7064',
    2: '#EBAB33',
    3: '#009783',
    4: '#0475BC'
  },
  tertiary: {
    1: '#F8D2CB',
    2: '#FFF2DF',
    3: '#C5E4C8',
    4: '#D1E8F8'
  },
  semantics: {
    default: '#1B1B1B',
    'link-light': '#EFF7FB',
    link: '#0475BC',
    'error-light': '#FEF5F8',
    error: '#EB003B',
    'success-light': '#ECF6F4',
    success: '#00856D',
    'success-dark': '#006A57',
    'info-light': '#F3F3F3',
    info: '#757575',
    'info-dark': '#454545',
    'warning-light': '#F8F3EC',
    warning: '#A85D00',
    disabled: '#CDCDCD'
  },
  gray: {
    0: '#FFFFFF',
    50: '#F6F6F6',
    100: '#F2F2F2',
    200: '#EAEAEA',
    300: '#CDCDCD',
    400: '#AEAEAE',
    500: '#909090',
    600: '#757575',
    700: '#5F5F5F',
    800: '#454545',
    900: '#303030',
    1000: '#1B1B1B',
    1100: '#000000'
  },
  peach: {
    100: '#FEF1EF',
    200: '#FFD8D5',
    300: '#FEB1AD',
    400: '#F18D83',
    500: '#ED7064',
    600: '#BF4D47'
  },
  yellow: {
    100: '#FFF2DF',
    200: '#F9E4BD',
    300: '#F3CD85',
    400: '#EFBC5C',
    500: '#EBAB33',
    600: '#CF8E14'
  },
  green: {
    100: '#E9F5F3',
    200: '#BDE4DF',
    300: '#7DCAC0',
    400: '#4FB7AA',
    500: '#009783',
    600: '#007162'
  },
  blue: {
    100: '#EBF5FC',
    200: '#D1E8F8',
    300: '#8CC0E1',
    400: '#4C9DCF',
    500: '#0475BC',
    600: '#024F7F'
  },
  purple: {
    100: '#E9EAF2',
    200: '#CFD1E4',
    300: '#A3A8CB',
    400: '#7E84B7',
    500: '#444E97',
    600: '#2C3261'
  }
};
var _default = colors;
exports.default = _default;

//# sourceMappingURL=colors.js.map